import { LegacyApartmentInfoStorageManager } from "./LegacyApartmentInfoStorageManager";
export const APARTMENT_INFO_KEY = "client_apartment_info";
export class ApartmentInfoStorageManager {
    constructor(params) {
        this.country = params.country;
    }
    store(apartmentInfo) {
        const apartmentInfoDataStrign = JSON.stringify(apartmentInfo);
        localStorage.setItem(APARTMENT_INFO_KEY, apartmentInfoDataStrign);
    }
    restore() {
        const apartmentInfoDataString = localStorage.getItem(APARTMENT_INFO_KEY);
        if (apartmentInfoDataString === null) {
            return new LegacyApartmentInfoStorageManager({
                country: this.country,
            }).restore();
        }
        return JSON.parse(apartmentInfoDataString);
    }
    erase() {
        localStorage.removeItem(APARTMENT_INFO_KEY);
    }
}
